import { PropsWithChildren } from 'react'

import { clsx } from '@writefull/utils'

interface ContainerProps {
  className?: string
}

export default function Container({
  className = '',
  children = '',
}: PropsWithChildren<ContainerProps>) {
  return <div className={clsx(className, 'mx-auto max-w-7xl px-4')}>{children}</div>
}
